<template>
  <div class="mapbox">
    <div class="container">
      <div class="closebtn" @click="$emit('closeDetail')">关闭 ×</div>

      <div class="content">
        <!-- 左侧：线下渠道 -->
        <div class="channel-block left-block">
          <div class="channel-header">线下渠道</div>
          <div class="offline-grid">
            <div class="offline-item">
              <img src="../assets/images/channel/offline1.jpg" alt="上海西郊国际农产品交易中心" />
            </div>
            <div class="offline-item highlight-yellow">
              <img src="../assets/images/channel/offline2.jpg" alt="线下市场2" />
            </div>
            <div class="offline-item">
              <img src="../assets/images/channel/offline3.jpg" alt="线下市场3" />
            </div>
            <div class="offline-item">
              <img src="../assets/images/channel/offline4.jpg" alt="杭州顺坝批发交易街区" />
            </div>
            <div class="offline-item">
              <img src="../assets/images/channel/offline5.png" alt="杭州水产市场" />
            </div>
            <div class="offline-item">
              <img src="../assets/images/channel/offline6.png" alt="杭州新农都市场" />
            </div>
          </div>
        </div>

        <!-- 分隔线 -->
        <!-- <div class="divider"></div> -->

        <!-- 右侧：线上渠道 -->
        <div class="channel-block right-block">
          <div class="channel-header">线上渠道</div>
          <div class="online-grid">
            <!-- 京东 -->
            <div class="platform-item jd">
              <img src="../assets/images/channel/logo-jd.jpg" alt="京东" />
            </div>
            <!-- 天猫 -->
            <div class="platform-item tmall">
              <img src="../assets/images/channel/logo-tmall.jpg" alt="天猫" />
            </div>
            <!-- 抖店 -->
            <div class="platform-item doudian">
              <img src="../assets/images/channel/logo-doudian.png" alt="抖店" />
            </div>
            <!-- 美团 -->
            <div class="platform-item meituan">
              <img src="../assets/images/channel/logo-meituan.jpg" alt="美团" />
            </div>
            <!-- 怡亚通 -->
            <div class="platform-item eternal">
              <img src="../assets/images/channel/logo-eternal.png" alt="怡亚通" />
            </div>
            <!-- 聚虾网 小程序 -->
            <div class="platform-item juxia">
              <!-- <div class="qrcode-wrap"> -->
              <a
                href="https://864234965.cms.n.weimob.com/bos/cms/864234965/6016909621965/16615859965/design/index?vid=0&essharewid=11120411965&share_vid=6016909621965&pmc=3%7C5.essharewid.0-3.vid.0-2%7C3%7C5.share_vid.86400"
                target="_blank"
                rel="noreferrer noopener">
                <img
                  class="qrcode-img"
                  src="../assets/images/channel/qrcode-juxia.png"
                  alt="聚虾网小程序码" />
              </a>
              <!-- <div class="qrcode-tip">点击图片跳转</div> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcommerceDetail',
  data() {
    return {}
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
}

.container {
  flex: 1;
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 0 15px 8px;
  cursor: pointer;
  font-size: 16px;
  flex-shrink: 0;
}

/* 主内容区 */
.content {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  overflow: hidden;
  padding: 0 30px;
  justify-content: center;
}

.channel-block {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  padding: 0 20px 15px;
  overflow: hidden;
}

.left-block {
  flex: 2.5;
}

.right-block {
  flex: 1;
}

.channel-header {
  color: #fff;
  font-size: 22px;
  text-align: center;
  margin-bottom: 30px;
  letter-spacing: 4px;
  flex-shrink: 0;
}

/* 分隔线 */
.divider {
  width: 1px;
  background: rgba(131, 255, 225, 0.25);
  margin: 20px;
  flex-shrink: 0;
}

/* ===== 线下渠道：2×2 图片网格 ===== */
.offline-grid {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 30px;
  overflow: hidden;
}

.offline-item {
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid transparent;
  background: #0a1a2e;
}

.offline-item img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  display: block;
}

/* ===== 线上渠道：2×3 logo 网格 ===== */
.online-grid {
  /* flex: 1; */
  justify-content: space-between;
  display: flex;
  gap: 60px;
  overflow: hidden;
  /* margin: 0 auto; */
}

.platform-item {
  width: 150px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.platform-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 8px;
  box-sizing: border-box;
}

/* 平台背景色 */
.platform-item.jd {
  background: #e8232a;
}
.platform-item.tmall {
  background: #e8232a;
}
.platform-item.doudian {
  background: #eef2f8;
}
.platform-item.meituan {
  background: #f5c400;
}
.platform-item.eternal {
  background: #eef2f8;
}

/* 聚虾网：白底 + 二维码 */
.platform-item.juxia {
  background: #fff;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
}

.qrcode-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* gap: 6px; */
}

.qrcode-img {
  width: 100%;
  max-width: 150px;
  aspect-ratio: 1;
  object-fit: contain;
}

.qrcode-tip {
  font-size: 14px;
  color: #333;
  text-align: center;
  line-height: 1.3;
  margin-bottom: 4px;
}
</style>
